<ng-container *hasRole="item.permission">
    <ng-container *ngIf="!item['visible'] || (item.visible | async)">
        <a  *ngIf="item.url"
            class="nav-link"
            [ngClass]="{'compressed-text': item.id === '1edtech'}"
            [routerLink]="[item.url]" routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
            matRipple
        >
            <mat-icon class="nav-link-icon icon" *ngIf="item.icon">{{item.icon}}</mat-icon>
            <mat-icon class="nav-link-icon icon" *ngIf="item.svgicon" svgIcon="{{item.svgicon}}"></mat-icon>
            <span class="nav-link-icon icon" *ngIf="item.faIcon">
                <fa-icon class="icon" icon="{{item.faIcon}}"></fa-icon>
            </span>

            <span class="nav-link-icon icon" *ngIf="item.id === 'sso'" style="height: auto;">
                <fa-layers class="icon-layers">
                    <fa-icon class="icon" [icon]="['fas', 'cloud']"></fa-icon>
                    <fa-icon class="icon" [inverse]="true" [icon]="['fas', 'key']" transform="shrink-8 down-1 right-1"></fa-icon>
                </fa-layers>
            </span>

            <span class="nav-link-icon icon" *ngIf="item.id === 'reports'" style="height: auto;">
                <fa-layers class="icon-layers">
                    <fa-icon class="icon" [icon]="['fas', 'file-alt']"></fa-icon>
                    <fa-icon class="icon" [inverse]="true" [icon]="['fas', 'circle']" transform="shrink-4 down-5 right-5"></fa-icon>
                    <fa-icon class="icon" [icon]="['fas', 'check-circle']" transform="shrink-6 down-5 right-5"></fa-icon>
                </fa-layers>
            </span>

            <span class="nav-link-icon icon" *ngIf="item.id === 'apiexplorer'" style="height: auto;">
                <fa-layers class="icon-layers">
                    <fa-icon class="icon" [icon]="['fas', 'tv']"></fa-icon>
                    <fa-layers-text content="API" style="font-weight: 600;" transform="shrink-10 up-0.7"></fa-layers-text>
                </fa-layers>
            </span>

            <span class="nav-link-icon icon" *ngIf="item.id === 'vendorApplication'" style="height: auto;">
                <fa-layers class="icon-layers">
                    <fa-icon class="icon" [icon]="['far', 'window-maximize']"></fa-icon>
                    <fa-icon class="icon" [inverse]="true" [icon]="['fas', 'circle']" transform="shrink-4 down-5 right-5"></fa-icon>
                    <fa-icon class="icon" [icon]="['fas', 'cog']" transform="shrink-6 down-5 right-5"></fa-icon>
                </fa-layers>
            </span>

            <span class="nav-link-icon icon" *ngIf="item.id === '1edtech'" style="height: auto;">
                <span class="one-edtech-logo"></span>
            </span>

            <span class="nav-link-icon icon" *ngIf="item.id === 'school-passport' || item.id === 'pii-console'" style="height: auto;">
                <span class="school-passport-logo"></span>
            </span>

            <span class="nav-link-title">
                {{item.title}}
                <fa-icon *ngIf="item?.target"
                         icon="external-link-alt"
                         class="icon"
                         style="font-size: 13px; vertical-align: bottom; margin-left: 8px;"
                ></fa-icon>
            </span>

            <span class="nav-link-badge" *ngIf="item.badge && (!item.badge.show$ || (item.badge.show$ | async)) && !item.badge.url"
                  [ngStyle]="{'background-color': item.badge.bg$ ? (item.badge.bg$ | async) : item.badge.bg,'color': item.badge.fg}">
                {{item.badge.title$ ? (item.badge.title$ | async) : item.badge.title}}
            </span>

            <a class="nav-link-badge" *ngIf="item.badge && (!item.badge.show$ || (item.badge.show$ | async)) && item.badge.url"
               [routerLink]="[item.badge.url]" routerLinkActive="active"
               [ngStyle]="{'background-color': item.badge.bg$ ? (item.badge.bg$ | async) : item.badge.bg,'color': item.badge.fg}">
                {{item.badge.title$ ? (item.badge.title$ | async) : item.badge.title}}
            </a>
        </a>

        <span class="nav-link" *ngIf="item.function" (click)="item.function()" matRipple>
            <mat-icon class="nav-link-icon" *ngIf="item.icon">{{item.icon}}</mat-icon>
            <mat-icon class="nav-link-icon" *ngIf="item.svgicon" svgIcon="{{item.svgicon}}"></mat-icon>
            <span class="nav-link-icon icon" *ngIf="item.faIcon">
                <fa-icon class="icon" icon="{{item.faIcon}}"></fa-icon>
            </span>

            <span class="nav-link-icon icon" *ngIf="item.id === 'reports'" style="height: auto;">
                <fa-layers class="icon-layers">
                    <fa-icon class="icon" [icon]="['fas', 'database']"></fa-icon>
                    <fa-icon class="icon" [inverse]="true" [icon]="['fas', 'circle']" transform="shrink-5 down-4.2 right-4"></fa-icon>
                    <fa-icon class="icon" [icon]="['fas', 'check-circle']" transform="shrink-7 down-4.2 right-4"></fa-icon>
                </fa-layers>
            </span>

            <span class="nav-link-icon icon" *ngIf="item.id === 'apiexplorer'" style="height: auto;">
                <fa-layers class="icon-layers">
                    <fa-icon class="icon" [icon]="['fas', 'tv']"></fa-icon>
                    <fa-layers-text content="API" style="font-weight: 600;" transform="shrink-10 up-0.7"></fa-layers-text>
                </fa-layers>
            </span>

            <span class="nav-link-icon icon" *ngIf="item.id === 'school-passport' || item.id === 'pii-console'" style="height: auto;">
                <span class="school-passport-logo"></span>
            </span>

            <span class="nav-link-title">
                {{item.title}}
                <fa-icon *ngIf="item?.target"
                         icon="external-link-alt"
                         class="icon"
                         style="font-size: 13px; vertical-align: bottom; margin-left: 8px;"
                ></fa-icon>
            </span>

            <span class="nav-link-badge" *ngIf="item.badge && (!item.badge.show$ || (item.badge.show$ | async)) && !item.badge.url"
                  [ngStyle]="{'background-color': item.badge.bg$ ? (item.badge.bg$ | async) : item.badge.bg,'color': item.badge.fg}">
                {{item.badge.title$ ? (item.badge.title$ | async) : item.badge.title}}
            </span>

            <a class="nav-link-badge" *ngIf="item.badge && (!item.badge.show$ || (item.badge.show$ | async)) && item.badge.url"
               [routerLink]="[item.badge.url]" routerLinkActive="active"
               [ngStyle]="{'background-color': item.badge.bg$ ? (item.badge.bg$ | async) : item.badge.bg,'color': item.badge.fg}">
                {{item.badge.title$ ? (item.badge.title$ | async) : item.badge.title}}
            </a>
        </span>
    </ng-container>
</ng-container>
